import { siteHandles, type Locale } from "@i18next/ui";

export interface Tag {
    id: string;
    siteId: string;
    slug: string;
    uri: string;
    title: string;
}

export interface Type {
    label: string;
    uri?: string;
    section?: Array<string>;
}

export interface Topic {
    id: string;
    siteId: string;
    slug: string;
    title: string;
    color: string;
}

export interface Posts {
    id: string;
    siteId: number;
    slug: string;
    title: string;
    sectionHandle: string;
    blogFeaturedImage: any;
    typeHandle: string;
    private: boolean;
    uri: string;
    url: string;
    postDate: string;
    tags: Array<Tag>;
    topics: Array<Topic>;
}

export interface Data {
    entries: Array<Posts>;
    entryCount: number;
    loading?: boolean;
}

export interface ParseResource {
    id: string;
    siteId: number;
    slug: string;
    title: string;
    sectionHandle: string;
    typeHandle: string;
    uri: string;
    url: string;
    postDate: string;
    private?: boolean;
    blogFeaturedImage: any;
    tags?: Array<Tag>;
    topics?: Array<Topic>;
    blogCategories?: Array<Topic>;
    type?: string;
}
const defaultImageUrl = "https://assets.avepoint.com/upload/blog/featured-image/default-feature-image.png";
export const parseResources = (entries: Array<Posts>):Array<ParseResource> => {
  return !entries ? [] : entries.map(({ blogFeaturedImage, ..._val }) => {
    switch (_val?.sectionHandle) {
      case "posts":
        return {
          type: "Blog",
          blogFeaturedImage: blogFeaturedImage.find((i: any) => true) ?? defaultImageUrl,
          ..._val,
        };
      default:
        return {
          type: "Resource",
          blogFeaturedImage: defaultImageUrl,
          ..._val,
        };
    }
  });
};

export const toResourceCards = (id: string = "#posts-cards") => {
    const navHeight = document.querySelector('.navbar')?.clientHeight ?? 0;
    const formtyElement = document.querySelector(id) as HTMLElement;
    if (formtyElement)
        document.body.scrollTo({top: formtyElement.getBoundingClientRect().top + document.body.scrollTop - navHeight - 50, behavior: 'smooth'});
}



export const orders = {
    latest: "postDate DESC",
    oldest: "postDate ASC",
};

interface ParamProps {
    locale?: Locale;
    type?: Array<string>;
    topic?: string;
    sort?: string;
    excludes?: Array<string>;
    page?: number;
    limit?: number;
}

export const GetList = (param: ParamProps, success: (res: Data) => void, error: (reason: any) => void) => {
    const {locale = "default", type, topic, sort = "latest", excludes = [], page = 1, limit = 18} = param;
    const params = new URLSearchParams();
    params.set("site", siteHandles[locale]);
    !!topic && params.set("topic", topic);
    params.set("orderBy", orders[sort as keyof typeof orders]);
    if(excludes.length > 0)
        params.append("id", "not");
    excludes.forEach(id => params.append("id", id));
    params.set("page", `${page}`);
    params.set("limit", `${limit}`);
    fetch(`/api/blog.json?${params.toString()}`) ///ex. /api/blog.json?site=default&topic=536949&orderBy=postDate+DESC&id=not&id=1007958&id=1008802&id=1008985&page=1&limit=18
        .then(res => res.json())
        .then((res:Data) => {
            success(res);
            return res;
        })
        .catch(reason => {
            error(reason);
            return undefined;
        });
};